import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";
import { setLoading } from "../loading/loadingSlice";

export const postFcmToken = createAsyncThunk("/fcm_registration", async ({ body }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.post(`/api/v1/cc/fcm_registration`, {
      ...body,
    });
    return response.data;
  } catch (error) {
    console.error("Error regestring fcm token:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error regestring fcm token";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const delFcmToken = createAsyncThunk("/fcm_deregister", async ({ body }, { dispatch }) => {
  try {
    dispatch(setLoading(true));
    const response = await api.post(`/api/v1/cc/fcm_deregister`, {
      ...body,
    });
    return response.data;
  } catch (error) {
    console.error("Error deregestring fcm token:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error deregestring fcm token";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const getAllNotification = createAsyncThunk("notifications", async ({ page, limit }, { dispatch }) => {
  try {
    // dispatch(setLoading(true));
    const params = {
      page,
      limit,
      sort: "isRead",
    };
    const response = await api.get(`/api/v1/cc/notifications`, {
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching notification list:", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error fetching notification list";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const readNotification = createAsyncThunk("readNotificatioon", async ({ userId }, { dispatch }) => {
  try {
    // dispatch(setLoading(true));
    const response = await api.patch(`/api/v1/cc/notifications/${userId}`);
    return response.data;
  } catch (error) {
    console.error("Error reading notification :", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error reading notification";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const languageSelect = createAsyncThunk("languageSelect", async ({ data }, { dispatch }) => {
  try {
    // dispatch(setLoading(true));
    const response = await api.post(`/api/v1/cc/language-select`, { ...data });
    return response.data;
  } catch (error) {
    console.error("Error", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
export const getAdminPrivilege = createAsyncThunk("getAdminPrivilege", async (_, { dispatch }) => {
  try {
    // dispatch(setLoading(true));
    const response = await api.get(`/api/v1/cc/admin_privilege`);
    return response.data;
  } catch (error) {
    console.error("Error", error);
    const errorMessage = error.response && error.response.data ? error.response.data.message : "Error";
    throw new Error(errorMessage);
  } finally {
    dispatch(setLoading(false));
  }
});
